(function () {
  'use strict';

  var btn = document.getElementById('whatsapp-floating-button');
  if (!btn) return;

  var ctx = window.ccWaContext || {};
  var bubble = document.getElementById('ccs-wa-bubble');
  var bubbleText = document.getElementById('ccs-wa-bubble-text');
  var bubbleCTA = document.getElementById('ccs-wa-bubble-cta');
  var bubbleClose = bubble && bubble.querySelector('.cc-wa-bubble__close');

  // ============ Config desde data-attrs (todo viene del schema de la section) ============
  function readNum(attr, fallback) {
    var v = parseInt(btn.getAttribute(attr), 10);
    return isNaN(v) ? fallback : v;
  }
  var BUBBLE_ENABLED = btn.getAttribute('data-bubble-enabled') === '1';
  var APPEAR_LIMIT = readNum('data-bubble-max', 3);
  var BUBBLE_FIRST_DELAY_MS = readNum('data-bubble-first-delay-ms', 2000);
  var BUBBLE_DURATION_MS = readNum('data-bubble-duration-ms', 6000);
  var BUBBLE_INTERVAL_MS = readNum('data-bubble-interval-ms', 20000);
  var BUBBLE_ONE_TIME = btn.getAttribute('data-bubble-one-time') === '1';
  var BUBBLE_CTA_VISIBLE = btn.getAttribute('data-bubble-cta-visible') === '1';
  var BUBBLE_OFFSET_X = readNum('data-bubble-offset-x', 4);
  var BUBBLE_OFFSET_Y = readNum('data-bubble-offset-y', 0);
  var BUBBLE_WIDTH = readNum('data-bubble-width', 280);
  var WA_HREF = btn.getAttribute('data-wa-href') || '';
  var PULSE_ENABLED = btn.getAttribute('data-pulse-enabled') === '1';
  var PULSE_INTERVAL_MS = readNum('data-pulse-interval-ms', 8000);
  var PULSE_FIRST_DELAY_MS = readNum('data-pulse-first-delay-ms', 4000);

  var bubbleMsgsRaw = btn.getAttribute('data-bubble-msgs') || '';
  var msgs = bubbleMsgsRaw.split('|').map(function (m) { return m.trim(); }).filter(Boolean);
  if (!msgs.length) msgs = ['¿Te ayudo en algo?'];

  // ============ Tracking ============
  function trackClick() {
    var name = ctx.productName || 'N/A';
    try {
      if (typeof fbq === 'function') {
        fbq('trackCustom', 'WhatsAppBuyClick', { product_name: name, page: window.location.href });
      }
    } catch (e) {}
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'whatsapp_buy_click', { event_category: 'engagement', event_label: name });
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_click',
        whatsapp_template: ctx.template || 'unknown',
        whatsapp_product_name: name
      });
    } catch (e) {}
  }
  btn.addEventListener('click', trackClick, { passive: true });
  if (bubbleCTA) bubbleCTA.addEventListener('click', trackClick, { passive: true });

  // ============ Animación pulse periódica ============
  var lastInteraction = Date.now();
  function noteInteraction() { lastInteraction = Date.now(); }
  ['scroll', 'mousemove', 'touchstart', 'click', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, noteInteraction, { passive: true });
  });

  function triggerPulse() {
    if (document.hidden) return;
    var idleFor = Date.now() - lastInteraction;
    if (idleFor < 2000) return;
    btn.classList.remove('cc-wa-fab--pulse');
    void btn.offsetWidth;
    btn.classList.add('cc-wa-fab--pulse');
    setTimeout(function () { btn.classList.remove('cc-wa-fab--pulse'); }, 2600);
  }

  if (PULSE_ENABLED) {
    setTimeout(function () {
      triggerPulse();
      setInterval(triggerPulse, PULSE_INTERVAL_MS);
    }, PULSE_FIRST_DELAY_MS);
  }

  // ============ Burbuja con mensajes rotativos ============
  if (!BUBBLE_ENABLED || !bubble || !bubbleText) return;

  var bubbleAppearances = 0;
  var bubbleHideTimer = null;

  // Posiciona la burbuja a la izquierda del botón Y alinea la punta con el centro REAL del botón.
  // Independiente del alto de la burbuja (que cambia según contenido o animación de scale).
  function positionBubble() {
    // Tanto el botón como la burbuja son position:fixed → coordenadas relativas al viewport.
    // NO sumar window.scrollY/scrollX (eso movía la burbuja fuera de pantalla al hacer scroll).
    var btnRect = btn.getBoundingClientRect();
    var btnCenterY = btnRect.top + btnRect.height / 2;
    // offset_y: positivo = burbuja más abajo del botón. La punta sigue apuntando al centro real del botón.
    var bubbleCenterY = btnCenterY + BUBBLE_OFFSET_Y;

    // Ancho: respetar el setting del schema, pero limitado por el espacio disponible a la izquierda del botón.
    var safeMargin = 8;
    var availableWidth = btnRect.left - BUBBLE_OFFSET_X - safeMargin;
    if (availableWidth < 140) availableWidth = 140; // mínimo razonable
    var finalWidth = Math.min(BUBBLE_WIDTH, availableWidth);
    bubble.style.width = finalWidth + 'px';

    // Posición horizontal: el bubble tiene transform: translate(-100%, -50%), su DERECHA queda en `left`.
    var left = btnRect.left - BUBBLE_OFFSET_X;
    bubble.style.left = left + 'px';
    bubble.style.top = bubbleCenterY + 'px';

    // Punta apunta al centro REAL del botón → compensar el offset_y.
    // bubbleTop visual = bubbleCenterY - bubbleHeight/2.
    // tailTop (relativo al top del bubble) = btnCenterY - bubbleTop = bubbleHeight/2 - BUBBLE_OFFSET_Y
    var bubbleHeight = bubble.offsetHeight || 1;
    var tailTopPx = (bubbleHeight / 2) - BUBBLE_OFFSET_Y;
    if (tailTopPx < 8) tailTopPx = 8;
    if (tailTopPx > bubbleHeight - 8) tailTopPx = bubbleHeight - 8;
    bubble.style.setProperty('--cc-wa-tail-top', tailTopPx + 'px');
  }

  function showBubble() {
    if (bubbleAppearances >= APPEAR_LIMIT) return;
    if (document.hidden) return;
    bubbleText.textContent = msgs[bubbleAppearances % msgs.length];
    // Position primero (necesitamos altura final), luego mostrar
    bubble.setAttribute('aria-hidden', 'false');
    bubble.classList.remove('ccs-animate-out');
    bubble.classList.add('ccs-animate-in');
    // Posicionamiento después de que el browser haya layout-eado el contenido
    requestAnimationFrame(function () {
      positionBubble();
      // Re-posicionar al final de la animación de scale por si cambió la altura
      setTimeout(positionBubble, 320);
    });
    bubbleAppearances++;
    clearTimeout(bubbleHideTimer);
    bubbleHideTimer = setTimeout(hideBubble, BUBBLE_DURATION_MS);
  }
  function hideBubble() {
    if (bubble.getAttribute('aria-hidden') === 'true') return;
    bubble.classList.remove('ccs-animate-in');
    bubble.classList.add('ccs-animate-out');
    setTimeout(function () {
      bubble.setAttribute('aria-hidden', 'true');
      bubble.classList.remove('ccs-animate-out');
    }, 220);
  }

  if (bubbleClose) bubbleClose.addEventListener('click', function (e) {
    // Close button siempre cierra la burbuja sin disparar la navegación al WhatsApp.
    e.preventDefault();
    e.stopPropagation();
    hideBubble();
    bubbleAppearances = APPEAR_LIMIT;
  });

  // CTA dentro de la burbuja (modo "con CTA"): tracking. La navegación viene del href propio del CTA.
  // stopPropagation para que el click handler del bubble (abajo) no dispare un open() duplicado.
  if (bubbleCTA) bubbleCTA.addEventListener('click', function (e) {
    e.stopPropagation();
    trackClick();
    hideBubble();
  }, { passive: true });

  // Click en CUALQUIER parte de la burbuja → abre WhatsApp (independiente del modo).
  // - Modo simple (<a>): el href propio del <a> navega; solo tracking + hide.
  // - Modo con CTA (<div>): no hay href en el wrapper, así que abrimos manualmente la nueva ventana.
  bubble.addEventListener('click', function (e) {
    // Si el click vino del close button o del CTA, ya están manejados arriba con stopPropagation.
    if (bubble.tagName === 'A') {
      // Modo simple: dejar que el navegador siga el href del <a>. Solo tracking + hide.
      trackClick();
      hideBubble();
      return;
    }
    // Modo con CTA: bubble es <div>. Abrir WhatsApp manualmente.
    if (WA_HREF) {
      window.open(WA_HREF, '_blank', 'noopener');
    }
    trackClick();
    hideBubble();
  }, { passive: true });
  // Cursor pointer para indicar clickeable en modo div
  if (bubble.tagName !== 'A') {
    bubble.style.cursor = 'pointer';
  }

  window.addEventListener('scroll', positionBubble, { passive: true });
  window.addEventListener('resize', positionBubble, { passive: true });

  setTimeout(function () {
    showBubble();
    if (!BUBBLE_ONE_TIME) {
      setInterval(showBubble, BUBBLE_INTERVAL_MS);
    }
  }, BUBBLE_FIRST_DELAY_MS);
})();
